(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[972],{

/***/ 21423:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiles/kitchen-tiles",
      function () {
        return __webpack_require__(19255);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Page; },
  "getProductQueryServerSide": function() { return /* binding */ getProductQueryServerSide; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/newProductCard.jsx
var newProductCard = __webpack_require__(73403);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
// EXTERNAL MODULE: ./src/UnbxdProductCard.js
var UnbxdProductCard = __webpack_require__(64642);
// EXTERNAL MODULE: ./src/productCard.js
var productCard = __webpack_require__(93115);
// EXTERNAL MODULE: ./src/components/category.jsx
var category = __webpack_require__(95173);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./config.js
var config = __webpack_require__(83346);
;// CONCATENATED MODULE: ./src/utils/tiles.js
/**
 * Returns a BreadcrumbList schema for the given category.
 * The schema includes a link to the home page, followed by each
 * breadcrumb in the category's breadcrumbs array.
 *
 * @param {Object} cat - The category object for which to generate
 *   the schema.
 * @returns {Object} The schema as a JSON string, with the
 *   `__html` property.
 */ const breadsCrumbSchema = (cat)=>{
    let arr = [
        {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.orientbell.com"
        }
    ];
    for(let i = 0; i < cat.breadcrumbs.length; i++){
        arr.push({
            "@type": "ListItem",
            position: i + 2,
            name: cat.breadcrumbs[i].category_name,
            item: "https://www.orientbell.com/".concat(cat.breadcrumbs[i].category_url_path)
        });
    }
    return {
        __html: JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: arr
        })
    };
};
/**
 * Generates a structured data script for a webpage using Schema.org markup.
 *
 * @param {Object} data - The data object containing product and category information.
 * @param {Object} router - The router object providing the current path information.
 * @returns {Object} An object with an __html property containing the JSON-LD script
 * for the webpage's schema, including context, type, URL, headline, breadcrumb,
 * name, and description.
 */ const webPageSchema = (data, router)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    return {
        __html: '{\n        "@context": "https://schema.org",\n        "@type": "WebPage",\n        "url": "'.concat(router.asPath, '",\n        "headline": "",\n        "breadcrumb": "Home > Tiles > ').concat(((ref = data.products.currentcategory) === null || ref === void 0 ? void 0 : ref.breadcrumbs) ? (ref2 = (ref1 = data.products.currentcategory) === null || ref1 === void 0 ? void 0 : ref1.breadcrumbs[1]) === null || ref2 === void 0 ? void 0 : ref2.category_name : "", '",\n        "name": "').concat((ref3 = data.products) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.currentcategory) === null || ref4 === void 0 ? void 0 : ref4.meta_title, '",\n        "description": "').concat((ref5 = data.products) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.currentcategory) === null || ref6 === void 0 ? void 0 : ref6.meta_description, '"\n      }')
    };
};

;// CONCATENATED MODULE: ./pages/tiles/kitchen-tiles/index.jsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Products(\n    $filter: ProductAttributeFilterInput!\n    $sort: ProductAttributeSortInput!\n    $pageSize: Int!\n    $currentPage: Int!\n  ) {\n    products(\n      filter: $filter\n      sort: $sort\n      pageSize: $pageSize\n      currentPage: $currentPage\n    ) {\n      currentcategory {\n        name\n        description\n        dynamic_content\n        imageUrl\n        meta_keywords\n        meta_description\n        meta_title\n        schema\n        videoschema\n        breadcrumbs {\n          category_id\n          category_name\n          category_level\n          category_url_key\n          category_url_path\n        }\n      }\n      appliedFilters {\n        label\n        value\n        attribute_code\n      }\n      aggregations(filter: { category: { includeDirectChildrenOnly: true } }) {\n        attribute_code\n        count\n        label\n        options {\n          label\n          value\n          count\n          swatch_data {\n            type\n            value\n          }\n        }\n      }\n      subcategories {\n        id\n        name\n        imageUrl\n      }\n      total_count\n      items {\n        id\n        name\n        sku\n        url_key\n        price_range {\n          minimum_price {\n            regular_price {\n              value\n              currency\n            }\n            final_price {\n              value\n              currency\n            }\n            discount {\n              amount_off\n              percent_off\n            }\n          }\n          maximum_price {\n            regular_price {\n              value\n              currency\n            }\n            final_price {\n              value\n              currency\n            }\n            discount {\n              amount_off\n              percent_off\n            }\n          }\n        }\n        extraVariables {\n          skd_stock\n          dora_stock\n          hoskote_stock\n          west_zone_stock\n          tile_type\n          tile_area\n          factory\n          finish {\n            label\n            value\n            url_key\n          }\n          tile_design\n          is_enabled\n          is_new\n          image_url\n          ambience_image_url\n          product_url\n          tile_size\n          sq_ft_price\n        }\n      }\n      sort_fields {\n        default\n        options {\n          value\n          label\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}











var __N_SSP = true;
const getProductQueryServerSide = (0,lib/* gql */.Ps)(_templateObject());
const KitchenSections = [
    {
        type: "Explore Kitchen Wall and Backsplash Tiles",
        name: "wall",
        description: "Kitchen wall tiles are the perfect way to add a touch of elegance and style to your kitchen. They not only enhance the aesthetic appeal of the space but also provide a practical solution for protecting walls from moisture, stains, and heat. With a wide range of designs, colours, and textures available, you can easily find the perfect wall tiles that complement your kitchen decor. Whether you prefer classic ceramic tiles or modern glass mosaics, these tiles can transform your kitchen into a stylish and functional area. Explore our collection of kitchen wall tiles to find the ideal match for your home."
    },
    {
        type: "Explore Kitchen Floor Tiles",
        name: "floor",
        description: "Kitchen floor tiles are an essential element in creating a functional and stylish kitchen space. They not only provide a durable and easy-to-clean surface but also contribute to the overall aesthetic of the room. With a variety of materials, colours, and patterns available, you can choose the perfect floor tiles that suit your kitchen's design and your personal style. From classic ceramic tiles to modern porcelain and natural stone options, these tiles can enhance the beauty of your kitchen while ensuring it remains practical for everyday use. Explore our collection of kitchen floor tiles to find the ideal fit for your home."
    },
    {
        type: "Explore Kitchen Countertop Tiles",
        name: "counter",
        description: "Kitchen countertop tiles are a versatile and stylish option for enhancing the look and functionality of your kitchen. These tiles not only provide a durable surface for food preparation but also add a touch of elegance to your kitchen decor. With a wide range of materials, colours, and designs available, you can easily find the perfect countertop tiles that complement your kitchen's style. Whether you prefer classic ceramic tiles or modern glass mosaics, these tiles can transform your kitchen into a beautiful and practical space. Explore our collection of kitchen countertop tiles to find the ideal match for your home."
    }
];
function Page(param) {
    let { error , oldComponent =false , oldComponentProps , sizeProductList  } = param;
    var ref, ref1, ref2, ref3;
    const router = (0,next_router.useRouter)();
    const { data  } = oldComponentProps;
    const [oldComponentState, setOldComponentState] = (0,react.useState)(oldComponent);
    // Function to relocate to new UI Component
    oldComponentProps = {
        ...oldComponentProps,
        removeAllFilterAndRedirect: ()=>setOldComponentState(false)
    };
    if (error) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: error
    });
    if (oldComponentState) return /*#__PURE__*/ (0,jsx_runtime.jsx)(category/* default */.Z, {
        ...oldComponentProps
    });
    /**
   * Function to create a "view more" link for a given size and type.
   * @param {string} size - The size of the tiles (e.g. "600x600", "600x1200", etc.)
   * @param {string} type - The type of tiles (e.g. "wall", "floor", "counter")
   * @returns {string} The URL for the "view more" link
   */ const createViewMoreLink = (size, type)=>{
        // Determine the size and type for the URL
        let typeLabel;
        switch(type){
            case "wall":
                typeLabel = "walls-tiles";
                break;
            case "floor":
                typeLabel = "floor-tiles";
                break;
            case "counter":
                typeLabel = "counter-tiles";
                break;
            default:
                // If no type is given, default to "walls-tiles"
                typeLabel = "walls-tiles";
        }
        // Return the URL for the view more link
        return "/tiles/kitchen-tiles/".concat(size, "/").concat(typeLabel);
    };
    // New UI rendering
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charset: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: data.products.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: data.products.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: data.products.currentcategory.meta_description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: data.products.currentcategory.meta_keywords
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "format-detection",
                        content: "telephone=no"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect dns-prefetch",
                        href: "https://connect.facebook.net",
                        crossorigin: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect dns-prefetch",
                        href: "https://www.googletagmanager.com",
                        crossorigin: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        "http-equiv": "Accept-CH",
                        content: "viewport-width, width, device-memory, dpr, downlink, ect"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "pinterest-rich-pin",
                        content: "false"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: data.products.currentcategory.meta_description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: data.products.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "".concat(config/* default.API_ENDPOINT */.Z.API_ENDPOINT, "/media/img/logo.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "Orientbell"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:creator",
                        content: "Orientbell"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/tiles/kitchen-tiles")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: data.products.currentcategory.meta_description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: data.products.currentcategory.meta_title
                    }),
                    oldComponentProps.videoSchema && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: oldComponentProps.videoSchema.replace(/<script\s+type="application\/ld\+json">|<\/script>/g, "")
                        }
                    }),
                    ((ref = data.products) === null || ref === void 0 ? void 0 : (ref1 = ref.currentcategory) === null || ref1 === void 0 ? void 0 : ref1.schema) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: data.products.currentcategory.schema.split(/<script[^>]*>/g) // Split by opening <script> tags
                        .filter((schema)=>schema.trim()) // Filter out any empty strings
                        .map((schemaContent, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                type: "application/ld+json",
                                dangerouslySetInnerHTML: {
                                    __html: schemaContent.replace(/<\/script>/g, "")
                                }
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(config/* default.API_ENDPOINT */.Z.API_ENDPOINT, "/media/img/logo.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "text/javascript",
                        src: "https://cdn.roomvo.com/static/scripts/b2b/orientbell.js",
                        defer: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: webPageSchema(data, router)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: breadsCrumbSchema(data.products.currentcategory)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "category-bathroom-tile-section new-cate-bath-tile-sect",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container container-width",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bread-crumb-row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL,
                                            children: "Home"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/tiles",
                                            children: "Tiles"
                                        })
                                    }),
                                    data.products.currentcategory.breadcrumbs && data.products.currentcategory.breadcrumbs.map((bre, inddd)=>{
                                        if (inddd != 0 && bre.category_name != "All Tiles") {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/".concat(bre.category_url_path),
                                                    children: bre.category_name
                                                })
                                            }, inddd);
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "categry-heading-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    children: "Kitchen Tiles"
                                }),
                                ((ref2 = data.products) === null || ref2 === void 0 ? void 0 : ref2.currentcategory.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category_accordion_data ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: data.products.currentcategory.description.replace(/<p>\s*<\/p>/g, "")
                                        }
                                    })
                                })
                            ]
                        }),
                        KitchenSections.map((section, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "categry-tile-prod-row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "exp-tile-text-row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        children: section.type
                                                    }),
                                                    (()=>{
                                                        switch(section.name){
                                                            case "floor":
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "/tiles/kitchen-tiles/kitchen-floor-tiles",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        className: "btn btn-primary",
                                                                        children: "View All"
                                                                    })
                                                                });
                                                            case "wall":
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "/tiles/kitchen-tiles/kitchen-wall-tiles",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        className: "btn btn-primary",
                                                                        children: "View All"
                                                                    })
                                                                });
                                                            case "counter":
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "/tiles/kitchen-countertop",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        className: "btn btn-primary",
                                                                        children: "View All"
                                                                    })
                                                                });
                                                            default:
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "/tiles/kitchen-tiles",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        className: "btn btn-primary",
                                                                        children: "View All"
                                                                    })
                                                                });
                                                        }
                                                    })()
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: section.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "categry-explore-wrap",
                                        children: sizeProductList[section.name].map((obj, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "categry-explore-size-head",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: obj.size
                                                                }),
                                                                " Kitchen ",
                                                                section.name.replace(/^./, (char)=>char.toUpperCase()),
                                                                " ",
                                                                "Tiles"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "categry-explore-row",
                                                        children: Array.isArray(obj.product) && obj.product.map((prod, productIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(newProductCard/* NewProductCard */.u, {
                                                                product: prod
                                                            }, productIndex))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "explore-pro-btn-row",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: createViewMoreLink(obj.size, section.name),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "btn btn-primary",
                                                                children: "View More"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, idx))
                                    })
                                ]
                            }, index)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "category_accordion_data",
                            dangerouslySetInnerHTML: {
                                __html: (ref3 = data.products) === null || ref3 === void 0 ? void 0 : ref3.currentcategory.dynamic_content.replace(/<p>\s*(&nbsp;)?\s*<\/p>/g, "")
                            }
                        })
                    ]
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7312,5518,4585,7615,6212,6737,7528,7933,3372,7349,166,4441,9774,2888,179], function() { return __webpack_exec__(21423); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);